import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "../../assets/css/component.css";
import "./signup.css";
import "../../assets/css/modal.css";
import close from "../../assets/svgs/close.svg";
import warley from "../../assets/svgs/warley.svg";
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Step1 from '../Modals/Step1';
import Step2 from '../Modals/Step2';
import Step3 from '../Modals/Step3';
import { withTranslation } from "react-i18next";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const removeCharAt = (string, index) => {
  const arr = string.split("")
  arr.splice(index, 1)
  return arr.join("")
}

const insert = (string, index, newString) => {
  if (index >= 0) {
    return string.substring(0, index) + newString + string.substring(index)
  }
}

const validDay = (string) => {
  if (string.length === 2) {
    const day = string.substring(0, 2)
    if (isNaN(day)) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}

const validMonth = (string) => {
  if (string.length === 5) {
    const month = string.substring(3, 5)
    if (isNaN(month)) {
      return false
    } else if (string.substring(2, 3) === "/") {
      return true
    }
  } else {
    return false
  }
}



const Signup = (props) => {
  const { register, reset, handleSubmit, watch, setValue } = useForm();
  const [checked, setChecked] = useState(1);
  const [signInVal, setSignInVal] = useState(null);
  const [show, setShow] = useState(null);
  const [clLogin, setClogin] = useState(false);
  const timerRef = useRef(null);
  const defaultError = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    birthDay: "",
    otp: "",
  };

  const [errors, setErrors] = useState(defaultError);

  const [phoneCode, setPhoneCode] = useState("+65");
  const [isOtpVerified, setOtpVerified] = useState(false);
  const [isVerifying, setVerifying] = useState(false);
  //Element references
  const mobileNumberElement = useRef(null);
  const countryCodeElement = useRef(null);
  const [DOB, setDOB] = useState("");
  const stringPlacement = useRef(0);
  const keyCode = useRef("");
  // const DOBElement = useRef(null);
  const recaptchaRef = useRef();
  const [captchaToken, setCaptchaToken] = useState(null);
  const onSubmit = (data) => {
    setErrors({ ...defaultError });
    const newError = {
      birthDay: "",
      phoneNumber: "",
    };
    {/*if (
      !/^[0-9]{2}[\/]{1}[0-9]{2}[\/]{1}[0-9]{4}$/g.test(
        data?.dob
      )
    ) {
      newError["birthDay"] = "Invalid birth day";
    }
*/}
    // Validate date format
    if (!captchaToken) {
      toast.error("Please verify the CAPTCHA first");
      return;
    }

    if (!/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/g.test(data?.dob)) {
      newError["birthDay"] = "Invalid date format";
    } else {
      const [day, month, year] = data.dob.split("/").map(Number);
      const currentYear = new Date().getFullYear();
      const minYear = 1900;
      const maxYear = currentYear - 18; // must be at least 18

      // Check day validity
      if (day < 1 || day > 31) {
        newError["birthDay"] = "Invalid date";
      }
      // Check month validity
      else if (month < 1 || month > 12) {
        newError["birthDay"] = "Invalid month";
      }
      // Check year validity
      else if (year < minYear || year > currentYear) {
        newError["birthDay"] = "Invalid year";
      }
      // Check if under 18
      else {
        const today = new Date();
        const dobDate = new Date(year, month - 1, day);
        const age = today.getFullYear() - dobDate.getFullYear();
        const m = today.getMonth() - dobDate.getMonth();

        if (age < 18 || (age === 18 && m < 0)) {
          newError["birthDay"] = "You must be at least 18 years old";
        }
      }
    }

    if (phoneCode != "+91" && !/^(6|8|9)\d{7}$/.test(mobileNumberElement.current.value)) {
      newError["phoneNumber"] = "Invalid phone number";
    }

    if (!newError.birthDay && !newError.phoneNumber) {
      const dob = data?.dob;
      let dobFormat = "";
      if (dob) {
        const parts = dob.split("/"); // ["02", "05", "2000"]
        if (parts.length === 3) {
          dobFormat = `${parts[2]}-${parts[1]}-${parts[0]}`; // 2000-05-02
        }
      }
      let newData = {
        ...props.signupVal,
        last_name: data.last_name,
        first_name: data.first_name,
        gender: checked === 1 ? "Male" : "Female",
        mobile: props?.user?.contact_number
          ? props?.user?.contact_number
          : phoneCode + mobileNumberElement.current.value,
        contact_number: props?.user?.contact_number
          ? props?.user?.contact_number
          : phoneCode + mobileNumberElement.current.value,
        dob: dobFormat,
        otp: data.otp,
        platform: 'fooddelivery'
      };
      props.setSignup(newData);
      props.nextStep();
      // reset();
    }
    setErrors({ ...errors, ...newError });
  };
  const showModal = (event, val) => {
    event && event.preventDefault();
    setShow(val);
  };

  const ChnageChecked = (value) => {
    setChecked(value);
  };
  const setLoginValue = (data) => {
    setSignInVal(data);
  };
  const loginClicked = (data) => {
    if (data.password && data.phone && !clLogin) {
      props.loginUser(data, true);
      console.log("login clicked");
      setClogin(true);
    }
  };
  const CloseloggedIn = () => {
    setShow(null);
  };

  function handleClick(event) {
    event.preventDefault();
    props.closeModal();

    showModal(event, 1);
  }

  const countries = [
    {
      name: "SG",
      phoneCode: "+65",
    },
    {
      name: "IN",
      phoneCode: "+91",
    },
  ];

  useEffect(() => {
    if (props?.user?.country_code_value) {
      setPhoneCode(props.user.country_code_value);
    }
  }, [props?.user?.country_code_value]);


  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  const [isSending, setSending] = useState(false);
  const [otpTimer, setOtpTimer] = useState(60);
  const [otpSent, setOtpSent] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });

  const sendMobileOTP = async () => {

    console.log("test", props?.user);

    //   if (!captchaToken) {
    //   // setAlert({
    //   //   message: "Please verify the CAPTCHA first",
    //   //   type: "error"
    //   // });
    //   toast.error("Please verify the CAPTCHA first");
    //   setTimeout(() => setAlert(null), 3000);
    //   return;
    // }
    try {
      setOtpVerified(false);
      const payload = {
        contact_number:
          props?.user?.country_code_value + props?.user?.partial_number,
        business_id: localStorage.getItem("business_id"),
        country_code: props?.user?.country_code_value,
        // captcha_token: captchaToken,
      };

      setSending(true);

      const response = await axios.post("auth/send-otp", payload, {
        headers: { "Content-Type": "application/json" },
      });
      const data = response.data;
      console.log(data.success, "gsfdhjkl;");
      setSending(false);

      if (data.success) {
        toast.success("OTP has been sent. You will receive it shortly.");

        setOtpSent(true);
        setOtpTimer(60);

        // Clear any previous timer before starting a new one
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        // Start a new countdown
        timerRef.current = setInterval(() => {
          setOtpTimer((prevTimer) => {
            if (prevTimer <= 1) {
              clearInterval(timerRef.current);
              setOtpSent(false);
              return 0;
            }
            return prevTimer - 1;
          });
        }, 1000);
      } else {
        toast.error(data?.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        "Failed to send OTP. Please try again later."
      );
    } finally {
      setSending(false);
    }
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);


  const verifyOTP = async () => {
    // if (!captchaToken) {
    //   // setAlert({
    //   //   message: "Please verify the CAPTCHA first",
    //   //   type: "error"
    //   // });
    //   toast.error("Please verify the CAPTCHA first");
    //   setTimeout(() => setAlert(null), 3000);
    //   return;
    // }
    try {
      const payload = {
        contact_number:
          props?.user?.country_code_value + props?.user?.partial_number,
        otp: watch("otp"),
        business_id: localStorage.getItem("business_id"),
        country_code: props?.user?.country_code_value,
      };

      setVerifying(true);

      const response = await axios.post("auth/verify_otp_twilio", payload, {
        headers: { "Content-Type": "application/json" },
      });

      const data = response.data;
      setVerifying(false);

      if (data.success && data.valid) {
        setOtpVerified(true);
        toast.success("OTP verified successfully!");
      } else {
        setOtpVerified(false);
        setOtpSent(false);
        setValue("otp", "");
        toast.error("Verification failed. Please try again.");
      }
    } catch (error) {
      setVerifying(false);
      setOtpVerified(false);
      setOtpSent(false);
      setValue("otp", "");
      toast.error("Verification failed. Please try again.");
    }
  };
  // useEffect(()=>{
  //   if (keyCode.current === "Backspace") {
  //     setDOB(removeCharAt(DOB, stringPlacement.current))
  //   } else {

  //   }

  // }, [DOB])

  const resendOTP = () => {
    sendMobileOTP();
  };
  const resetOtpStates = () => {
    setOtpSent(false);
    setOtpTimer(0);
    setValue("otp", ""); // clear OTP field
    setOtpVerified(false);
    setVerifying(false);
    setSending(false);

    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    setCaptchaToken(null);
    if (recaptchaRef.current) recaptchaRef.current.reset();
  };

  useEffect(() => {
    if (!props.show) {
      resetOtpStates();
    }
  }, [props.show]);


  return (
    <Modal
      show={props.show}
      onHide={props.joinus ? () => { } : props.closeModal}
      dialogClassName="su-dialog"
      contentClassName="su-content"
      centered
    >
      <Step1
        show={show === 1 ? true : false}
        closeModal={() => setShow(null)}
        showNext={(event) => showModal(event, 2)}
      />

      <Step2
        show={show === 2 ? true : false}
        closeModal={() => setShow(null)}
        signInVal={signInVal}
        setLoginValue={setLoginValue}
        showNext={(event) => showModal(event, 3)}
      />

      <Step3
        signInVal={signInVal}
        loginClicked={loginClicked}
        setLoginValue={setLoginValue}
        show={show === 3 ? true : false}
        closeModal={CloseloggedIn}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="su-body">
          {!props.joinus && (
            <ModalCloseButton onClick={() => { resetOtpStates(); props.closeModal(); }} />
          )}

          <div className="su-logo-wrap">
            <img src={warley} width="220" height="46" alt="warley" />
          </div>
          <div className="su-title">Sign up for WARELY account</div>

          {alert?.message && (
            <div className={`su-alert ${alert.type}`}>
              <span>{alert.message}</span>
              <button type="button" className="su-alert-close" onClick={() => setAlert({ message: "", type: "" })}>
                <FiX />
              </button>
            </div>
          )}

          {/* First name & Last name */}
          <div className="su-row">
            <div className="su-field">
              <label className="su-label">First name</label>
              <input
                minLength={3}
                required
                type="text"
                autoComplete="off"
                placeholder="Enter first name"
                {...register("first_name")}
                className="su-input"
              />
            </div>
            <div className="su-field">
              <label className="su-label">Last name</label>
              <input
                minLength={3}
                required
                type="text"
                autoComplete="off"
                placeholder="Enter last name"
                {...register("last_name")}
                className="su-input"
              />
            </div>
          </div>

          {/* Gender */}
          <div className="su-field">
            <label className="su-label">Gender</label>
            <div className="su-gender-group">
              <button type="button" className={`su-gender-btn${checked === 1 ? " active" : ""}`} onClick={() => ChnageChecked(1)}>Male</button>
              <button type="button" className={`su-gender-btn${checked === 2 ? " active" : ""}`} onClick={() => ChnageChecked(2)}>Female</button>
            </div>
          </div>

          {/* Birthday */}
          <div className="su-field">
            <label className="su-label">Birthday</label>
            <input
              maxLength={10}
              minLength={3}
              required
              placeholder="dd / mm / yyyy"
              type="text"
              autoComplete="off"
              {...register("dob", {
                onChange: (event) => {
                  event.target.value = event.target.value.replace(
                    /[^0-9\/]/,
                    ""
                  );
                  if (!(keyCode.current === "Backspace")) {
                    if (validDay(event.target.value)) {
                      event.target.value = event.target.value + "/";
                    }
                    if (validMonth(event.target.value)) {
                      event.target.value = event.target.value + "/";
                    }
                  }
                },
              })}
              onKeyDown={(event) => {
                keyCode.current = event.key === "Backspace" ? "Backspace" : "";
              }}
              className="su-inputs"
              id="dob"
            />
            {errors.birthDay && <div className="su-error">{errors.birthDay}</div>}
          </div>

          {/* Phone number */}
          <div className="su-field">
            <label className="su-label">Phone number</label>
            <div className="su-phone-group">
              <select
                ref={countryCodeElement}
                value={props?.user?.country_code_value || phoneCode}
                onChange={(e) => setPhoneCode(e.target.value)}
                disabled={!!props?.user?.country_code_value}
                className="su-country-select"
              >
                {countries.map(({ name, phoneCode: code }, index) => (
                  <option key={index} value={code}>{name}</option>
                ))}
              </select>
              <div className="su-phone-sep" />
              <div className="su-phone-code">
                {props?.user?.country_code_value ? props.user.country_code_value : phoneCode}
              </div>
              {props?.user?.partial_number ? (
                <input
                  type="text"
                  minLength={8}
                  maxLength={8}
                  id="mobileInputElement"
                  placeholder={props.user.partial_number}
                  ref={mobileNumberElement}
                  value={props.user.partial_number}
                  disabled
                  className="su-phone-input"
                />
              ) : (
                <input
                  type="text"
                  minLength={8}
                  maxLength={8}
                  id="mobileInputElement"
                  ref={mobileNumberElement}
                  className="su-phone-input"
                  onChange={() => { console.log(mobileNumberElement.current.value); }}
                />
              )}
            </div>
            {errors.phoneNumber && <div className="su-error">{errors.phoneNumber}</div>}
          </div>

          {/* OTP */}
          <div className="su-field">
            <label className="su-label">Enter OTP</label>
            <div className="su-otp-row">
              <input
                minLength={3}
                required
                type="text"
                autoComplete="off"
                {...register("otp")}
                placeholder="Enter OTP"
                id="otpInputElement"
                className="su-otp-input"
                disabled={!otpSent || isSending || isOtpVerified}
              />
              {!otpSent || isOtpVerified ? (
                <button
                  type="button"
                  className={`su-otp-btn${isOtpVerified ? " verified" : ""}`}
                  onClick={sendMobileOTP}
                  disabled={isSending || otpSent}
                >
                  {isSending ? "Sending..." : isOtpVerified ? "Verified" : "Send OTP"}
                </button>
              ) : (
                <button
                  type="button"
                  className={`su-otp-btn${isVerifying ? " verifying" : ""}`}
                  onClick={verifyOTP}
                  disabled={isVerifying || isOtpVerified}
                >
                  {isVerifying ? "Verifying..." : "Verify OTP"}
                </button>
              )}
            </div>
            {otpSent && otpTimer > 0 && !isOtpVerified && (
              <div className="su-otp-timer">
                Haven't received the code? <span>Resend in {otpTimer}s</span>
              </div>
            )}
          </div>

          <div className="su-captcha">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={(token) => setCaptchaToken(token)}
              onExpired={() => setCaptchaToken(null)}
            />
          </div>

          <div className="su-footer-text">
            Once successfully created, you can use WARELY account across all partners with WARELY
          </div>
          <button
            type="submit"
            className="su-submit-btn"
            style={{ marginTop: '22px' }}
            disabled={!isOtpVerified}
          >
            Continue
          </button>
          <div className="su-powered">Powered by Warely</div>
        </Modal.Body>
      </form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user
});

export default withTranslation()(
  connect(mapStateToProps)(Signup)
);


